<template>
  <div>
    <main-layout>
      <v-container>
        <template>
          <div>
            <v-tabs v-model="active" slider-color="primary">
              <v-tab v-for="(tab, i) in tabs" :key="i" ripple>
                {{ tab.label }}
              </v-tab>
              <v-tab-item :key="0">
                <customers> </customers>
              </v-tab-item>
              <v-tab-item :key="1" class="mt-5">
                <employee></employee>
              </v-tab-item>
            </v-tabs>
          </div>
        </template>
      </v-container>
    </main-layout>
  </div>
</template>
<script>
import customers from './Customers.vue'
import employee from './Employee.vue'
export default {
  components: {
    customers,
    employee
  },
  data() {
    return {
      search: '',
      active: null,
      tabs: [
        {
          label: this.$t('Customer')
        },
        {
          label: this.$t('employee')
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/kingKitchen/member/main.vue